"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDnd = require("react-dnd");

var _spaui = require("@tencent/spaui");

var _reactDndHtml5Backend = _interopRequireDefault(require("react-dnd-html5-backend"));

var _index = require("./utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var OverlayTrigger = _spaui.PopOver.OverlayTrigger,
    PopOver = _spaui.PopOver.PopOver;

var Item = /*#__PURE__*/function (_PureComponent) {
  _inherits(Item, _PureComponent);

  function Item() {
    _classCallCheck(this, Item);

    return _possibleConstructorReturn(this, _getPrototypeOf(Item).apply(this, arguments));
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          text = _this$props.text,
          connectDragSource = _this$props.connectDragSource,
          connectDropTarget = _this$props.connectDropTarget,
          item = _this$props.item,
          isOver = _this$props.isOver,
          canDrop = _this$props.canDrop,
          disabledId = _this$props.disabledId,
          hideFixedTipComponent = _this$props.hideFixedTipComponent,
          _this$props$emptyFixe = _this$props.emptyFixedTip,
          emptyFixedTip = _this$props$emptyFixe === void 0 ? '' : _this$props$emptyFixe;
      var content;
      var className = [];

      if (item === 'split') {
        className.push('split');

        if (isOver) {
          if (canDrop) {
            className.push('dropping');
          }
        }

        var horizontalText = _react["default"].createElement("div", {
          className: "spaui-columns-selected-tips spaui-hr-sect"
        }, "\u4EE5\u4E0A\u6307\u6807\u5C06\u6A2A\u5411\u56FA\u5B9A");

        var horizontalLine = '';

        if (hideFixedTipComponent) {
          return null;
        } else if (this.props.showGuideTips === 3) {
          horizontalLine = _react["default"].createElement(OverlayTrigger, {
            alignment: "top",
            trigger: "hover",
            placement: "left",
            overlay: this.props.guidePopOver('固定列（3/' + this.props.getGuideTotal() + '）', '将指标移动至横线上方后对应指标在表单中横向滑动时位置固定。', 3),
            show: this.props.showGuideTips === 3
          }, horizontalText);
        } else {
          if (this.props.show5LimitTips) {
            horizontalLine = _react["default"].createElement(OverlayTrigger, {
              trigger: "hover",
              show: true,
              placement: "left",
              overlay: _react["default"].createElement(PopOver, {
                className: "popover-dark"
              }, _react["default"].createElement("div", {
                className: "spaui-popover-title"
              }, "\u6700\u591A\u53EF\u8BBE\u7F6E\u4E94\u4E2A\u56FA\u5B9A\u5217\u6307\u6807"))
            }, horizontalText);
          } else {
            horizontalLine = _react["default"].createElement(OverlayTrigger, {
              trigger: "hover",
              delay: "0",
              placement: "left",
              overlay: _react["default"].createElement(PopOver, {
                className: "popover-columns popover-cool popover-mini",
                style: {
                  'width': '250px'
                }
              }, _react["default"].createElement("h4", {
                className: "spaui-popover-title"
              }, "\u56FA\u5B9A\u5217"), _react["default"].createElement("p", {
                className: "spaui-popover-body"
              }, "\u5F53\u9875\u9762\u51FA\u73B0\u6A2A\u5411\u6EDA\u52A8\u60C5\u51B5\u65F6\uFF0C\u5206\u5272\u7EBF\u4EE5\u4E0A\u6307\u6807\u5217\u4F4D\u7F6E\u5C06\u4FDD\u6301\u4E0D\u53D8\u3002"))
            }, horizontalText);
          }
        }

        content = _react["default"].createElement("li", {
          className: className.join(' ')
        }, horizontalLine);
      } else {
        if (item.unmovable) {
          className.push('fixed');
        }

        if (!item.deletable) {
          className.push('required');
        }

        if (disabledId === this.props.id) {
          className.push('disabled');
        }

        if (isOver) {
          if (canDrop) {
            className.push('dropping');
          }

          if (!canDrop) {
            className.push('disabled');
          }
        } // 默认的列


        if (item.id === 'default_fixed_column' && emptyFixedTip) {
          content = _react["default"].createElement("li", {
            className: className.join(' '),
            style: {
              background: 'none',
              color: 'rgba(0, 0, 0, 0.3)',
              padding: '5px',
              fontSize: '12px'
            }
          }, text);
        } else {
          content = _react["default"].createElement("li", {
            className: className.join(' ')
          }, _react["default"].createElement("i", {
            className: "icon icon-move-hand"
          }), _react["default"].createElement("span", {
            className: "spaui-columns-text"
          }, text), _react["default"].createElement("a", {
            className: "spaui-columns-action spaui-columns-remove spaui-cursor-pointer",
            onClick: function onClick() {
              _this.props.onDelete(_this.props.id);
            }
          }));
        }
      }

      return connectDragSource(connectDropTarget(content));
    }
  }]);

  return Item;
}(_react.PureComponent);

var type = 'item';
var itemSource = {
  beginDrag: function beginDrag(props) {
    return {
      id: props.id,
      item: props.item
    };
  },
  endDrag: function endDrag(props) {
    props.onReset();
  },
  canDrag: function canDrag(props, monitor) {
    var item = props.item; //横线不能拖

    if (item === 'split') {
      return false;
    } //配置的不能动的列也不能拖


    if (item.unmovable) {
      return false;
    }

    return true;
  }
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    canDrag: monitor.canDrag()
  };
}

var itemTarget = {
  hover: function hover(props, monitor) {
    var dragging = monitor.getItem();

    if (!monitor.canDrop() && props.item && !props.item.unmovable) {
      props.onDisabled(dragging.id);
    } else {
      props.onReset();
    }
  },
  drop: function drop(props, monitor) {
    var dragItem = monitor.getItem();
    var draggedId = dragItem.id || dragItem.item;
    var dropId = props.id || props.item; // console.log('------------drap--------')
    // console.log(dragItem)
    // console.log('drop---------------')
    // console.log(props.item)

    if (draggedId !== dropId) {
      props.moveItem(draggedId, props.id || props.item);
    }
  },
  canDrop: function canDrop(props, monitor) {
    var dragItem = monitor.getItem();
    var maxFixedNumber = props.maxFixedNumber,
        list = props.list,
        dropItem = props.dropItem;
    var splitIndex = list.indexOf('split'); // //完全不能移动的列，不能往这里放
    // if (dropItem.unmovable) {
    //     return false
    // }

    var dragItemIndex = list.findIndex(function (it) {
      return it.id === dragItem.id;
    });
    var dropItemIndex = -1;

    if (dropItem === 'split') {
      dropItemIndex = splitIndex;
    } else {
      dropItemIndex = list.findIndex(function (it) {
        return it.id === props.id;
      });
    } // console.log('splitIndex:' + splitIndex + ';dragItemIndex:' + dragItemIndex + ',dropItemIndex:' + dropItemIndex)
    //往下拖，随便拖


    if (dragItemIndex < dropItemIndex) {
      return true;
    } else if (dragItemIndex > dropItemIndex) {
      //横线下也随便拖
      if (dropItemIndex > splitIndex) {
        return true;
      } else {
        //横线上少于 maxFixedNumber 个 也可以拖上去
        if (splitIndex < maxFixedNumber) {
          // console.log('---------横线小于4 可以拖---------')
          return true;
        } else {
          if (dragItemIndex < splitIndex) {
            return true;
          } else {
            return false;
          }
        }
      }
    } else {
      return true;
    }
  }
};

function collectTaget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({
      shallow: true
    }),
    canDrop: monitor.canDrop()
  };
}

var Source = (0, _reactDnd.DragSource)(type, itemSource, collectSource)((0, _reactDnd.DropTarget)(type, itemTarget, collectTaget)(Item));

var DnD = /*#__PURE__*/function (_PureComponent2) {
  _inherits(DnD, _PureComponent2);

  function DnD(props) {
    var _this2;

    _classCallCheck(this, DnD);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(DnD).call(this, props));
    _this2.state = {
      diabledField: '',
      show5LimitTips: false
    };
    _this2.setCannotDragField = _this2.setCannotDragField.bind(_assertThisInitialized(_this2));
    _this2.clearCannotDragField = _this2.clearCannotDragField.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(DnD, [{
    key: "setCannotDragField",
    value: function setCannotDragField(id) {
      this.setState({
        diabledField: id
      });
    }
  }, {
    key: "clearCannotDragField",
    value: function clearCannotDragField() {
      var _this3 = this;

      var diabledField = this.state.diabledField;
      var newState = {
        diabledField: ''
      };

      if (diabledField) {
        newState.show5LimitTips = true;
        setTimeout(function () {
          _this3.setState({
            show5LimitTips: false
          });
        }, 1500);
      }

      this.setState(newState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          hideFixedTipComponent = _this$props2.hideFixedTipComponent,
          _this$props2$emptyFix = _this$props2.emptyFixedTip,
          emptyFixedTip = _this$props2$emptyFix === void 0 ? '' : _this$props2$emptyFix;
      var splitIndex = data.findIndex(function (it) {
        return it === 'split';
      });
      var head = data.slice(0, splitIndex + 1),
          tail = data.slice(splitIndex + 1);

      var headContent = _react["default"].createElement("div", {
        className: "spaui-columns-selected",
        key: "head"
      }, _react["default"].createElement("ul", {
        className: "spaui-columns-list"
      }, head.map(function (item, headItem) {
        return _react["default"].createElement(Source, {
          emptyFixedTip: emptyFixedTip,
          hideFixedTipComponent: hideFixedTipComponent,
          key: item.id || "key-".concat(headItem),
          list: data,
          disabledId: _this4.state.diabledField,
          item: item,
          id: item.id,
          text: item.text,
          maxFixedNumber: _this4.props.maxFixedNumber,
          deletable: item.deletable,
          onDelete: _this4.props.onDelete,
          guidePopOver: _this4.props.guidePopOver,
          getGuideTotal: _this4.props.getGuideTotal,
          showGuideTips: _this4.props.showGuideTips,
          moveItem: _this4.props.onMove,
          show5LimitTips: _this4.state.show5LimitTips,
          onDisabled: _this4.setCannotDragField,
          onReset: _this4.clearCannotDragField
        });
      })));

      var tailContentUl = _react["default"].createElement("ul", {
        className: "spaui-columns-list"
      }, tail.map(function (item) {
        return _react["default"].createElement(Source, {
          emptyFixedTip: emptyFixedTip,
          hideFixedTipComponent: hideFixedTipComponent,
          key: item.id,
          list: data,
          disabledId: _this4.state.diabledField,
          item: item,
          id: item.id,
          text: item.text,
          deletable: item.deletable,
          maxFixedNumber: _this4.props.maxFixedNumber,
          onDelete: _this4.props.onDelete,
          guidePopOver: _this4.props.guidePopOver,
          getGuideTotal: _this4.props.getGuideTotal,
          showGuideTips: _this4.props.showGuideTips,
          moveItem: _this4.props.onMove,
          onDisabled: _this4.setCannotDragField,
          onReset: _this4.clearCannotDragField
        });
      }));

      var tailContent = '';

      if (this.props.showGuideTips === 2) {
        tailContent = _react["default"].createElement(OverlayTrigger, {
          key: "tail-overlay-trigger",
          alignment: "top",
          trigger: "hover",
          placement: "left",
          overlay: this.props.guidePopOver('指标排序（2/' + this.props.getGuideTotal() + '）', '拖动已选指标进行排序，调整报表中各项数据的显示顺序，满足个性化关注需求。', 2),
          show: true
        }, tailContentUl);
      } else {
        tailContent = tailContentUl;
      }

      tailContent = _react["default"].createElement("div", {
        className: "spaui-columns-unselected",
        key: "tail"
      }, tailContent);
      return [headContent, tailContent];
    }
  }]);

  return DnD;
}(_react.PureComponent);

DnD.defaultProps = {
  data: [],
  onMove: _index.noop,
  //新手指引的第几步
  showGuideTips: false,
  //新手指引的生成文案
  guidePopOver: _index.noop,
  onDelete: _index.noop
};

var _default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend["default"])(DnD);

exports["default"] = _default;